import { render, staticRenderFns } from "./BotKeyboardMsg.vue?vue&type=template&id=6e2a14f3&scoped=true&lang=pug"
import script from "./BotKeyboardMsg.vue?vue&type=script&lang=js"
export * from "./BotKeyboardMsg.vue?vue&type=script&lang=js"
import style0 from "./BotKeyboardMsg.vue?vue&type=style&index=0&id=6e2a14f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a14f3",
  null
  
)

export default component.exports